import ListingService from "@/services/listing.service";

const state = () => ({
  list: [],
  allJobList: [],
  loading: false,
  error: null,
});

const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },
  SET_JOBS(state, payload) {
    state.list = payload;
  },

  SET_ALL_JOBS(state, payload) {
    state.allJobList = payload;
  },

  
  SET_ERROR(state, err) {
    state.error = err;
  },
};

const actions = {
  async fetchJobs({ commit }, params = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const res = await ListingService.getJobsPosted(params);

      // ← LOG THE WHOLE PAYLOAD HERE
      console.log("💾 [jobs] fetchJobs response:", res.data.data);

      // assuming your data is in res.data.data
      commit("SET_JOBS", res.data.data);
    } catch (err) {
      commit("SET_ERROR", err);
      console.error("❌ [jobs] fetchJobs failed:", err);
    } finally {
      commit("SET_LOADING", false);
    }
  },



   async fetchAllJobs({ commit }, params = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const res = await ListingService.getAllJobsPosted(params);

      // ← LOG THE WHOLE PAYLOAD HERE
      console.log("💾 [jobs] fetchJobs response:", res.data.data);

      // assuming your data is in res.data.data
      commit("SET_ALL_JOBS", res.data.data);
    } catch (err) {
      commit("SET_ERROR", err);
      console.error("❌ [jobs] fetchAllJobs failed:", err);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchJobById({ commit }, jobId) {
  commit("SET_LOADING", true);
  commit("SET_ERROR", null);
  try {
    const res = await ListingService.showJob(jobId);

    console.log("🔍 [jobs] fetchJobById:", res.data.data);

    return res.data.data; // You can return it directly to the component
  } catch (err) {
    commit("SET_ERROR", err);
    console.error("❌ [jobs] fetchJobById failed:", err);
    throw err;
  } finally {
    commit("SET_LOADING", false);
  }
}
,
  async applyForJob({ commit }, applicationData) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const res = await ListingService.storeJobApplication(applicationData);

      console.log("📄 [jobs] applyForJob response:", res.data);

      return res.data; // You can return it directly to the component
    } catch (err) {
      commit("SET_ERROR", err);
      console.error("❌ [jobs] applyForJob failed:", err);
      throw err;
    } finally {
      commit("SET_LOADING", false);
    }
  },

};


const getters = {
  allJobs: (state) => state.list,
  allJobListings: (state) => state.allJobList,
  isLoading: (state) => state.loading,
  fetchError: (state) => state.error,
  getJobById: (state) => (id) => {
    return state.list.find((job) => job.id === id);
  },  
  getJobBySlug: (state) => (slug) => {
    return state.list.find((job) => job.slug === slug);
  },  
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
